export const itemGridColumn = 'html-email-item-grid-column';
export const itemGridSpacer = 'html-email-item-grid-spacer';
//# sourceMappingURL=css-classes.js.map